<template>
  <div id="app">
    <Load key="Load" v-if="pageIndex===-1" v-on:setPage="setPage" :userData="userData"></Load>
    <Page1 key="Page1" v-if="pageIndex===1" v-on:setPage="setPage" @playSond="playSond" @pauseSond="pauseSond"></Page1>
    <Page2 key="Page2" v-if="pageIndex===2" v-on:setPage="setPage" :userData="userData" @setUser="setUser"></Page2>
    <Page3 key="Page3" v-if="pageIndex===3" v-on:setPage="setPage" :userData="userData" @setUser="setUser" @playSond="playSond"></Page3>
    <Page4 key="Page4" v-if="pageIndex===4" v-on:setPage="setPage" :userData="userData" @setUser="setUser" @playSond="playSond"></Page4>
    <Page5 key="Page5" v-if="pageIndex===5" v-on:setPage="setPage" :userData="userData" @setUser="setUser" @setPic="setPic"></Page5>
    <Page6 key="Page6" v-if="pageIndex===6" v-on:setPage="setPage" :userData="userData" @setUser="setUser" @resetPage="resetPage" @resetPage2="resetPage2" @setPid="setPid"></Page6>
    <div style="display:none;">
      <audio id="music" loop="loop"><source :src="Tool.pubPach+'mp3/bgm.mp3'"></audio>
    </div>
  </div>
</template>

<script>
import Load from "./components/Load.vue";
import Page1 from "./components/Page1.vue";
import Page2 from "./components/Page2.vue";
import Page3 from "./components/Page3.vue";
import Page4 from "./components/Page4.vue";
import Page5 from "./components/Page5.vue";
import Page6 from "./components/Page6.vue";
import Tool from './script/tool.js'
import { Howl } from "howler";

// document.title = Tool.pageTitle;
window.shareData={
    MsgImg:'http://cms-bucket.ws.126.net/2022/0126/2f4520b8j00r6aut2001cc0005k005kc.jpg',  //分享图片
    link:location.origin+location.pathname,    //分享链接
    title:Tool.shareTitle,   //分享标题
    desc:Tool.shareDesc,    //分享描述
    fText:Tool.shareTitle,    //分享朋友圈
    callback:function(){
        window.share_survey(true);
    }
};
window.NeteaseShareInit();

export default {
  name: 'App',
  components: {
    Load,Page1,Page2,Page3,Page4,Page5,Page6
  },
  data: function() {
      return {
        soundList:{},
        pageIndex: -1,
        Tool:Tool,
        userData:{
          me:{
            name:'安全驾驶员',
            tx:Tool.pubPach+'end/tx.png',
          },
          you:{
            pid:null,
            data:null
          },
          sel1:0,
          sel2:[],
          sel3:{},
          pic:0,
          juNum:0,
          base64:"",
        }
      };
  },
  mounted(){
    let that = this;


    // localStorage.setItem('20220126_talagon',new Date().getTime());
    // localStorage.setItem('sess','5298191429573582848');
    // localStorage.setItem('userName','ac');
    // localStorage.setItem('userHead','https://thirdwx.qlogo.cn/mmopen/vi_32/ajNVdqHZLLAVhWz7vsmdVz4QnUJibcRC6AzrfJ0MDUxzSOByUujpdqstIwz8ycqJDgSAbvBInKUQQbufEDPzHcA/132');
    // return false;

    if(!!window.netease.getPara('pid')){
      this.setPid();
    }

    if(Tool.isDev){
      that.setMe();
      return false;
    }

    if(window.netease.ua.weixin){
      if(Tool.wxIsLogin){
        that.setMe();
        return false;
      }
      const code = window.netease.getPara('code');
      if(code){
          that.setMe(code);
      }else{
          return Tool.login();
      }
    }
  },
  created(){
    let that = this;
    this.soundList["bgm"] = new Howl({
        src: Tool.pubPach+'mp3/bgm.mp3',
        loop: true,
        id: "bgm",
    });
    this.soundList["ren"] = new Howl({
        src: Tool.pubPach+'mp3/renwu.mp3',
        loop: false,
        id: "ren",
    });
    this.soundList["sel"] = new Howl({
        src: Tool.pubPach+'mp3/xuanxiang.mp3',
        loop: false,
        id: "sel",
    });
    this.soundList["zuo"] = new Howl({
        src: Tool.pubPach+'mp3/zuowei.mp3',
        loop: false,
        id: "zuo",
    });
    if(window.netease.ua.android){
      this.soundList["bgm"].play();
    }
    if(window.netease.ua.ios){
      document.addEventListener('DOMContentLoaded', function () {
        var audio = document.getElementById('music');
        audio.play();
        //循环播放
        audio.onended = function () {
            audio.load();
            audio.play();
        }
        document.addEventListener("WeixinJSBridgeReady", function () {
            audio.play();
            //循环播放
            audio.onended = function () {
                audio.load();
                audio.play();
            }
        }, false);
      });
    }
  },
  methods:{
    setPage(index){
      this.pageIndex = index;
    },
    resetPage(){
      this.pageIndex = 1;
    },
    resetPage2(){
      this.userData.you.pid = null;
      this.pageIndex = 1;
    },
    setUser(k,v){
      this.userData[k]=v;
      // console.log(this.userData)
    },
    setPic(n){
      this.userData.pic=this.getPic(n);
    },
    getPic(n){
      // console.log(n)
      // this.userData.sel1=1;
      // return 1;
      if(!n){
        n = this.userData.juNum;
      }
      if(n<=3){
        return 1;
      }
      if(n<=5){
        return 2;
      }
      if(n<=8){
        return 3;
      }
      if(n<=10){
        return 4;
      }
      if(n<=12){
        return 5;
      }
      if(n<=14){
        return 6;
      }
      if(n<=16){
        return 7;
      }
      return 8;
    },
    setPid(){
      let that = this;
      if((!window.netease.ua.weixin || !Tool.wxIsLogin) && !Tool.isDev){
        return false;
      }
      that.userData.you.pid = window.netease.getPara('pid');
      this.$http.post(Tool.urlData.getLists,{
          pid: that.userData.you.pid,
          sess: localStorage.getItem('sess'),
      },{emulateJSON:true}).then(({data})=>{
        if(typeof data == "string"){
          data = JSON.parse(data);
        }
        if(data.retCode==1){
          that.userData.you.data = data.retData;
          if(!that.userData.you.data.lists){
            that.userData.you.data.lists = [];
            that.userData.you.data.lists[0] = that.userData.you.data.details;
          }
          console.log(that.userData.you.data.lists)
          if(that.userData.sel1 > 0){
            that.setPic();
          }else{
            that.setPic(that.userData.you.data.lists[0].dist);
          }
        }else{
          that.userData.you.pid = null;
        }
      });
    },
    setMe(code){
      let that = this;
      code = !code ? "" : code;
      this.$http.post(Tool.urlData.getUserInfo,{
          code: code,
          sess: localStorage.getItem('sess'),
      },{emulateJSON:true}).then(({data})=>{
        if(typeof data == "string"){
          data = JSON.parse(data);
        }
        if(data.retCode!=1){
            return Tool.login();
        }else{
          localStorage.setItem('sess',data.retData.sess);
          localStorage.setItem('20220126_talagon',new Date().getTime());
          localStorage.setItem('userName',data.retData.nickname);
          localStorage.setItem('userHead',data.retData.headimgurl);
          that.userData.me.tx=data.retData.headimgurl;
          that.userData.me.name=data.retData.nickname;
          Tool.wxIsLogin = true;
          if(!!window.netease.getPara('pid')){
            that.setPid();
          }
        }
      });
    },
    playSond(key){
      this.soundList[key].play();
    },
    pauseSond(key){
      this.soundList[key].pause();
    }
  }
}
</script>

<style lang="scss">
*{margin:0;padding:0;}
html,body{padding:0;margin:0;overflow-x: hidden;background: #eee;width: 100%;height: 100%;}
body{font-size: 0.12rem;-webkit-tap-highlight-color: transparent;position: fixed;}
body, html {
  position: fixed;
  top: 0px;
  bottom: 0px;
  width: 100%;
  height: 100%;
}
div,button,input,img,a{ outline: none; -webkit-tap-highlight-color: transparent;}
em,i{font-style: normal;}
#app {
  font-family: sy,Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
  position: absolute;
  // position: fixed;
  left:0;
  top:0;
  right:0;
  bottom:0;
  overflow: hidden;
  background: url(./assets/bg01.png) no-repeat 0 0 / 100% 100%;
}
.touchicon{
  position: absolute;
  transform: scale(1.1);
  z-index: 100;
}
.touchend1,.touchend2,.touchend3,.touchend4,.touchend5,.touchend6{
  position: absolute;
  transform: scale(1);
  z-index: 90;
}
.jimgout1,.jimgout4,.jimgout6{
  position: absolute;
  bottom:1.5rem;
  right:1.5rem;
  max-height: 1.35rem;
}
.jimgout2,.jimgout5{
  position: absolute;
  bottom:1.5rem;
  left:1.2rem;
  max-height: 1.35rem;
}
.jimgout3{
  position: absolute;
  bottom:1.9rem;
  left:0.4rem;
  max-height: 1.35rem;
}
.icon{
  width: 2.18rem;
  height: 2.18rem;
  background-image: url(./assets/bg69.png);
  background-size: 18.58rem 7.42rem;
  background-repeat: no-repeat;
  // transform: scale(0.82);
}
.icon1_1{
  background-position: 0.16rem 0.06rem;
}
.icon1_2{
  background-position: -2.24rem 0.06rem;
}
.icon1_3{
  background-position: -4.64rem 0.06rem;
}
.icon1_4{
  background-position: -7.04rem 0.06rem;
}
.icon1_5{
  background-position: -9.44rem 0.06rem;
}
.icon1_6{
  background-position: -11.84rem 0.06rem;
}
.icon1_7{
  background-position: -14.24rem 0.06rem;
}
.icon1_8{
  background-position: -16.64rem 0.06rem;
}
.icon2_1{
  background-position: 0.16rem -2.6rem;
}
.icon2_2{
  background-position: -2.24rem -2.6rem;
}
.icon2_3{
  background-position: -4.64rem -2.6rem;
}
.icon2_4{
  background-position: -7.04rem -2.6rem;
}
.icon2_5{
  background-position: -9.44rem -2.6rem;
}
.icon2_6{
  background-position: -11.84rem -2.6rem;
}
.icon2_7{
  background-position: -14.24rem -2.6rem;
}
.icon2_8{
  background-position: -16.64rem -2.6rem;
}
.icon3_1{
  background-position: 0.16rem 100%;
}
.icon3_2{
  background-position: -2.24rem 100%;
}
.icon3_3{
  background-position: -4.64rem 100%;
}
.icon3_4{
  background-position: -7.04rem 100%;
}
.icon3_5{
  background-position: -9.44rem 100%;
}
.icon3_6{
  background-position: -11.84rem 100%;
}
.icon3_7{
  background-position: -14.24rem 100%;
}
.icon3_8{
  background-position: -16.64rem 100%;
}

.qianduanwz{
  position: absolute;
  left:0;
  top:0;
  width: 7.5rem;
  height: 14.48rem;
  .bg{
    position: absolute;
    left:0;
    top:0;
    width: 7.5rem;
    height: 14.48rem;
  }
  .tx{
    position: absolute;
    left:0.24rem;
    top:1.09rem;
    width: 1.36rem;
    height: 1.02rem;
    background: url(./assets/bg93.png) no-repeat 0 0 / 100% 100%;
    img{
      position: absolute;
      left: 0.22rem;
      top: 0.02rem;
      width: 0.97rem;
      height: 0.97rem;
      border-radius: 100%;
    }
    &::after{
      content: '';
      position: absolute;
      left: 0;
      top: 0.42rem;
      width: 1.36rem;
      height: 0.43rem;
      background: url(./assets/bg94.png) no-repeat 0 0 / 100% 100%;
    }
  }
  .name{
    position: absolute;
    left:1.85rem;
    top:1.06rem;
    width: 3.6rem;
    font-size: 0.4rem;
    line-height: 0.8rem;
    height: 0.8rem;
    text-align: left;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }
  .num{
    position: absolute;
    right:0;
    top:3.27rem;
    top: 3.97rem;
    right: -0.71rem;
    width: 3rem;
    font-size: 1.1rem;
    line-height: 1.58rem;
    height: 1.58rem;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    transform: rotate(90deg);
  }
  .ewm{
    position: absolute;
    left:0;
    bottom:0;
    width: 7.5rem;
    height: 2.3rem;
  }
}

@keyframes transformAni {
  50%{
      transform:none;
  }
}
@keyframes transformAni2 {
  100%{
      transform:none;
  }
}
@keyframes opacityAni{
  100%{
    opacity: 0;
  }
}
@keyframes opacityAni2{
  100%{
    opacity: 1;
  }
}
</style>
